import { Box, Card, CardContent, Button, CardMedia, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Styles from '../Config/Styles'
import { storage } from '../Config/Storage';
import { getdraftOrders } from '../Redux/Mycart/action';
import { useDispatch, useSelector } from 'react-redux';

const Mycart2 = ({ cart }) => {
    const { orders } = useSelector((state) => state?.CartData) || [];
    const dispatch = useDispatch()
    const [file, setFile] = useState(null);
    const rfq = storage.fetch.rfq()

    useEffect(() => {
        dispatch(getdraftOrders({ session: sessionStorage.getItem("session") }))
    }, [file])
    useEffect(() => {

    }, [orders])




    return (
        <Box sx={{ ...Styles.middleBoxStyle().box, "&.MuiBox-root": { p: rfq ? 2 : 0, pt: 0 }, width: "30%" }}>
            <Box sx={{ width: "100%" }}>
                <Typography
                    variant="h5"
                    sx={{ pt: '16px', fontWeight: 'bold', color: '#333', mb: !orders?.length && rfq === undefined ? 10 : 3, pl: orders && 2 }}
                >
                    {rfq && orders ? "My RFQ Request" : rfq ? "My RFQ Request" : "My Cart"}
                </Typography>
                {orders?.length ? <><Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#07D6E5',
                        padding: '8px',

                    }}
                >
                    <img src={require('../assets/Group.png')} width={"30px"} style={{ margin: 2 }} />
                    {!rfq && <Typography variant="body2" sx={{ ml: 2, width: '70%', fontWeight: 500 }}>Delivered Within 3-4 Days</Typography>}
                </Box>
                    {orders?.map((item) => <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '12px',
                            borderRadius: 2,
                            pb:0
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={item?.order_image ? `https://api-dev.tabta.net/assets/${item?.order_image}?cache-buster=2025-01-02T11:33:33.214Z&key=system-large-contain` : require('../assets/dummy.jpg')}
                            alt="Product"
                            sx={{ width: 70, height: 70, borderRadius: 1, marginRight: '12px' }}
                        />

                        <CardContent sx={{ padding: 0 }}>
                            <Typography variant="subtitle1" sx={{ fontSize: '14px', fontWeight: 'bold', textAlign: "start" }} noWrap>
                                {item?.product_name}
                            </Typography>
                            <Box sx={{
                                display: "flex",
                                flexWrap: "wrap"

                            }}>
                                {Array.isArray(item?.details) &&
                                    item.details.map((val, idx) => (
                                        <Typography
                                            key={idx}
                                            variant="body2"
                                            sx={{
                                                fontSize: '12px',
                                                color: 'gray',
                                                whiteSpace: 'nowrap',
                                                maxWidth: "85%",
                                            }}
                                        >
                                            {val?.attribute_value}{"|"}
                                        </Typography>
                                    ))}
                                <Typography variant="body2" sx={{ fontSize: '12px', color: 'gray', whiteSpace: 'nowrap', maxWidth: "85%" }}>{item?.quantity}{item?.unit}</Typography>

                            </Box>
                        </CardContent>
                    </Box>)}

                </>
                    : <Box sx={{ width: "100%" }}>
                        <Typography sx={{ fontWeight: 700, textAlign: "start" }}>Attachment</Typography>
                        <Box sx={{ border: "1px solid gray", mt: 2, mb: 2, p: 2, borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography>{rfq}</Typography>
                        </Box>

                    </Box>}
            </Box >
        </Box>
    )
}

export default Mycart2